import { useRef, useState } from "react";
import { Upload, RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "../../lib/api";
import { Panel } from "./Panel";

export const LogoPanel = ({ logo, onLogo }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const run = async (fn) => {
    setBusy(true);
    try {
      onLogo(await fn());
      toast.success("Logo updated");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel step="01 / Source" title="Your logo" testid="logo-panel">
      <div className="bg-[#e5e7eb] rounded-xl aspect-[5/2] flex items-center justify-center overflow-hidden">
        {logo ? (
          <img data-testid="logo-preview-img" src={fileUrl(logo.path)} alt="Logo" className="w-full h-full object-contain" />
        ) : (
          <Loader2 className="w-5 h-5 animate-spin text-gray-500" />
        )}
      </div>
      <input
        ref={input}
        type="file"
        accept="image/png,image/jpeg,image/webp"
        className="hidden"
        data-testid="logo-upload-input"
        onChange={(e) => {
          const f = e.target.files?.[0];
          e.target.value = "";
          if (f) run(() => api.uploadLogo(f));
        }}
      />
      <div className="flex gap-3 mt-4">
        <button data-testid="logo-upload-button" disabled={busy} onClick={() => input.current?.click()}
          className="btn-ghost flex-1 rounded-full py-2.5 text-sm flex items-center justify-center gap-2">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Swap logo
        </button>
        <button data-testid="logo-reset-button" disabled={busy} onClick={() => run(api.resetLogo)}
          className="btn-ghost rounded-full px-4 py-2.5 text-sm flex items-center gap-2" title="Back to OOshots logo">
          <RotateCcw className="w-4 h-4" /> Reset
        </button>
      </div>
    </Panel>
  );
};
